export const accessoryList = {
  navTitle: '附件',
  prompt: {
    alreadyDelete: '文件已经被删除',
    alreadyDeleteFile: '您访问的文件已被删除'
  }
}
